import React, { useEffect, useState } from "react";
import "./endpoint.css";
import instance from "../../ApiInstance/Inetrceptor";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Drawer,
  Grid,
  Button,
  InputLabel,
  TextField,
  Typography,
  Alert,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const SourceEndpointDrawer = ({
  getSourceEndPoint,
  isDrawerOpen,
  setIsDrawerOpen,
  drawerCaller,
  setBackDrop,
}) => {
  const type = drawerCaller?.name ?? "Add";
  const filledInfo = drawerCaller?.data ?? {};
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "xs"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "sm"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "md"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  let drawerWidth = "600px";
  if (isXs || window.innerWidth < 1000) {
    drawerWidth = "250px";
  } else if (isSm) {
    drawerWidth = "300px";
  } else if (isMd) {
    drawerWidth = "400px"; 
  } else if (isLg) {
    drawerWidth = "600px"; 
  } else if (isXl) {
    drawerWidth = "600px"; 
  }
  const [error, setError] = useState(null);
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [loader, setLoader] = useState(true);
  const [success, setSuccess] = useState(null);
  const [information, setInformation] = useState({});
  const [endpointTableData, setEndpointTableData] = useState([]);
  const handleDrawerClose = (event) => {
    // if (event.target.id === "back-button") {
      setIsDrawerOpen(false);
    // }
  };
  const getSourceEndPointType = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/EndpointType/Get", body)
      .then((res) => {
        console.log("gridd",res);
        if (res?.data?.Success) {
            setEndpointTableData((prev) => {
              return [...prev, ...(res?.data?.Value ?? {})];
            });
          }
        }) 
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const createNewEndPointApi = () => {
    const EndpointName = information?.source_endpoint_name?.trim();
    const EndpointAdd = information?.source_endpoint_address?.trim();
    const EndpointTypeID = information?.source_endpoint_type_id;
    const EndpointUserName = information?.source_endpoint_username?.trim();
    const EndpointPassword = information?.source_endpoint_password?.trim();
    if (
      EndpointName?.length == 0 ||
      EndpointTypeID?.length == 0 ||
      EndpointUserName?.length == 0 ||
      EndpointPassword?.length == 0 ||
      EndpointAdd?.length == 0
    ) {
      setError("Please fill all the mandatory fields");
      setTimeout(() => {
        setError(null);
      }, 5000);
      return;
    }
    setBackDrop(true);
    const body = {
      source_endpoint_id: information?.source_endpoint_id,
      source_endpoint_name: information?.source_endpoint_name,
      source_endpoint_address: information?.source_endpoint_address,
      source_endpoint_type_id: information?.source_endpoint_type_id,
      source_endpoint_working_path: information?.source_endpoint_working_path,
      source_endpoint_archive_path: information?.source_endpoint_archive_path,
      source_endpoint_username: information?.source_endpoint_username,
      source_endpoint_password: information?.source_endpoint_password,
      source_endpoint_absolute_path: information?.source_endpoint_absolute_path,
      source_endpoint_port: information?.source_endpoint_port,
      source_endpoint_type_name: information?.source_endpoint_type_name,
      source_endpoint_absolute_path: information?.source_endpoint_absolute_path,
      source_endpoint_port: information?.source_endpoint_port,
    };
    instance
      .post("api/v1/Master/Endpoint/Post", body)
      .then((res) => {
        if (res?.data?.Success) {
          setError(null);
          setSuccess(res?.data?.ResultMessage);
          getSourceEndPoint();
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
        } else {
          setError(res?.data?.ResultMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
        if(type === "Add")
        {
        setInformation({
          source_endpoint_name:  "",
          source_endpoint_address:  "",
          source_endpoint_type_id: "",
          source_endpoint_working_path:"",
          source_endpoint_archive_path: "",
          source_endpoint_username: "",
          source_endpoint_password: "",
          source_endpoint_absolute_path:"",
          source_endpoint_port:""
        });
      }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBackDrop(false);
      });
  };
  const onchangeHandler = (event) => {
    const { id, value } = event.target;
    const sanitizedValue =
    id === "source_endpoint_port" ? value.replace(/[^0-9]/g, "") : value;
    setInformation((prev) => {
      return {
        ...prev,
        [id]: sanitizedValue,
      };
    });
  };
  const handleArrowBackClick = (e) => {
    e.stopPropagation();
    handleDrawerClose();
  };
  useEffect(() => {
    setInformation({
      source_endpoint_id: filledInfo?.source_endpoint_id ?? 0,
      source_endpoint_name: filledInfo?.source_endpoint_name ?? "",
      source_endpoint_address: filledInfo?.source_endpoint_address ?? "",
      source_endpoint_type_id: filledInfo?.source_endpoint_type_id,
      source_endpoint_working_path:
        filledInfo?.source_endpoint_working_path ?? "",
      source_endpoint_archive_path:
        filledInfo?.source_endpoint_archive_path ?? "",
      source_endpoint_username: filledInfo?.source_endpoint_username ?? "",
      source_endpoint_password: filledInfo?.source_endpoint_password ?? "",
      source_endpoint_absolute_path:
        filledInfo?.source_endpoint_absolute_path ?? "",
      source_endpoint_port: filledInfo?.source_endpoint_port ?? "",
      source_endpoint_type_name: filledInfo?.source_endpoint_type_name ?? "",
    });
  }, [drawerCaller]);

  useEffect(() => {
    getSourceEndPointType();
  }, []);
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      //   onClose={handleDrawerClose}
      PaperProps={{
        sx: {
          width: drawerWidth, // Set the width dynamically
        },
      }}
    >
      <div
        style={{ padding: "20px" }}
        // onClick={handleDrawerClose}
        // onKeyDown={handleDrawerClose}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backEndpoint"
              onClick={handleDrawerClose}
              startIcon={<ArrowBackIcon onClick={handleDrawerClose}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colorEndpoint mb-0"
              style={{ fontWeight: "600" }}
            >
              {type == "Add" ? "Add" : "Edit"} Source Endpoint{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colorEndpoint mb-1"
              style={{ fontWeight: "600" }}
            >
              Source Endpoint Information{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={
                  <CancelIcon
                    onClick={() => setError(null)}
                    style={{ cursor: "pointer" }}
                  />
                }
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="source_endpoint_name">
              Endpoint Name<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              id="source_endpoint_name"
              size="small"
              value={information?.source_endpoint_name}
              onChange={onchangeHandler}
              // placeholder="Enter name"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="source_endpoint_address">
              Endpoint Address<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              id="source_endpoint_address"
              size="small"
              value={information?.source_endpoint_address}
              onChange={onchangeHandler}
              // placeholder="Enter name"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="source_endpoint_type_id">
              Endpoint Type<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Autocomplete
              size="small"
              id={"success_alert_type_id"}
              options={endpointTableData}
              getOptionLabel={(option) => option.endpoint_type_name}
              value={
                endpointTableData.find(
                  (option) => option.endpoint_type_id
                  === information.source_endpoint_type_id
                ) || null
              }
              onChange={(event, newValue) => {
                setInformation((prev) => {
                  console.log("newValue",newValue);
                  return {
                    ...prev,
                    source_endpoint_type_id: newValue?.endpoint_type_id || 0,
                    source_endpoint_type_name: newValue?.endpoint_type_name || null
                  };
                });
              }}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="outlined"
                  // InputProps={{
                  //   ...params.InputProps,
                  //   endAdornment: (
                  //     <InputAdornment
                  //     position="end"
                  //     style={{ position: "absolute", right: 20 }}
                  //   >
                  //       <img
                  //         src="assets/Images/searchicon.svg"
                  //         alt="Search Icon"
                  //       />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              )} />
            {/* <TextField
              id="source_endpoint_type_id"
              size="small"
              value={information?.source_endpoint_type_id}
              onChange={onchangeHandler}
              // placeholder="Enter name"
              variant="outlined"
              fullWidth
            /> */}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="source_endpoint_working_path">
              Endpoint Working Path
            </InputLabel>
            <TextField
              id="source_endpoint_working_path"
              size="small"
              value={information?.source_endpoint_working_path}
              onChange={onchangeHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="source_endpoint_archive_path">
            Archive Path
            </InputLabel>
            <TextField
              id="source_endpoint_archive_path"
              size="small"
              value={information?.source_endpoint_archive_path}
              onChange={onchangeHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="source_endpoint_username">
              Endpoint UserName<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              id="source_endpoint_username"
              size="small"
              value={information?.source_endpoint_username}
              onChange={onchangeHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="source_endpoint_password">
              Endpoint Password<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              id="source_endpoint_password"
              size="small"
              value={information?.source_endpoint_password}
              onChange={onchangeHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="source_endpoint_absolute_path">
            Absolute path
            </InputLabel>
            <TextField
              id="source_endpoint_absolute_path"
              size="small"
              value={information?.source_endpoint_absolute_path}
              onChange={onchangeHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="source_endpoint_port">
             Port
            </InputLabel>
            <TextField
              id="source_endpoint_port"
              size="small"
              value={information?.source_endpoint_port}
              onChange={onchangeHandler}
              variant="outlined"
              fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={() => {
                console.log(information, "information");
                createNewEndPointApi();
              }}
            >
              {type == "Add" ? "Create" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default SourceEndpointDrawer;
